import { Skeleton } from '@renderer/components/ui/skeleton'

// Cycled so the placeholder list reads as varied titles, not identical bars.
const TITLE_WIDTHS = ['w-44', 'w-56', 'w-36', 'w-52', 'w-40', 'w-48']

interface HistoryListSkeletonProps {
  count?: number
}

/**
 * Loading placeholder mirroring the flat `HistoryRow` (icon dot + title bar),
 * shared by the History view and Home's Recents preview.
 */
export function HistoryListSkeleton({ count = 8 }: HistoryListSkeletonProps) {
  return (
    <div className="flex flex-col gap-[2px]">
      {Array.from({ length: count }, (_, i) => (
        // border-transparent matches the row's resting hairline slot, so real
        // rows landing in place of the skeleton don't nudge the list by 2px.
        <div key={i} className="flex items-center gap-2 border border-transparent px-3 py-2">
          <Skeleton className="bg-skeleton corner-smooth size-5 rounded-md" />
          <Skeleton className={`bg-skeleton h-4 ${TITLE_WIDTHS[i % TITLE_WIDTHS.length]}`} />
        </div>
      ))}
    </div>
  )
}
